<template>
  <v-layout align-center justify-center align-content-center>
    <modal
      name="errorModal"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 225px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Error</v-toolbar-title>
        </v-toolbar>
        <v-card-subtitle>
          Something went wrong. Please try again. If the error persists, please
          contact support.
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00558C" dark @click="$modal.hide('errorModal')"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <modal
      name="savedModal"
      :draggable="!isMobile"
      :clickToClose="false"
      height="auto"
      :width="450"
    >
      <v-card style="height: 225px">
        <v-toolbar color="#00558C" dark>
          <v-toolbar-title>Changes Saved</v-toolbar-title>
        </v-toolbar>
        <br />

        <v-card-subtitle
          >Agency name/address changes have been saved.</v-card-subtitle
        >
        <br />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#00558C"
            dark
            @click="
              $modal.hide('savedModal');
              getAgencies(false);
            "
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </modal>

    <div class="drop">
      <v-layout justify-center align-content-center align-center column>
        <v-icon color="green" size="100">mdi-lead-pencil</v-icon>

        <v-card-title
          style="color: #00558c; font-weight: bold; text-align: center"
          >Agency Office Name <br v-if="$vuetify.breakpoint.xs" />&amp;<br
            v-if="$vuetify.breakpoint.xs"
          />
          Address Editor</v-card-title
        >
        <v-card-subtitle
          >Edit agency names, addresses and phone numbers.</v-card-subtitle
        >
        <br />

        <form>
          <v-select
            v-if="!isAgencyUser"
            v-model="selectedAO"
            :items="sortedAoItems"
            item-text="ao"
            item-value="id"
            label="Please Select an Agency Owner"
            persistent-hint
            return-object
            single-line
            solo
            style="max-width: 400px"
            @input="getAgencies(false)"
            :menu-props="{ maxHeight: 175 }"
          ></v-select>
          <v-progress-circular
            indeterminate
            color="green"
            v-if="waitCircle"
            size="50"
            class="waitCircle"
          ></v-progress-circular>

          <v-select
            :menu-props="{ maxHeight: 100 }"
            :disabled="!enableAgencySelection"
            v-model="select"
            :items="sortedAgencies"
            item-text="name"
            item-value="id"
            label="Please Select an Agency"
            persistent-hint
            return-object
            single-line
            solo
            style="width: 400px"
          ></v-select>
          <!-- @input="gotoAddressChange" -->

          <!-- <v-layout align-end align-content-end justify-end>
 <v-btn color="green" dark class="menuBtn" @click.stop="gotoAddressChange">Submit</v-btn> 
          </v-layout>-->
        </form>
      </v-layout>
      <br />
      <br />
      <v-layout justify-end align-content-end align-end>
        <v-btn
          color="green"
          class="menuBtn"
          dark
          @click="$router.push('/')"
          style="margin-right: 10px"
          >Return to Main Menu</v-btn
        >
        <v-btn
          color="green"
          dark
          class="menuBtn"
          @click.stop="gotoAddressChange"
          >Edit</v-btn
        >
        <!-- <v-btn color="green" class="menuBtn" dark @click="$router.push('/')">Return to Main Menu</v-btn> -->
      </v-layout>
    </div>
    <span v-if="dialog">
      <v-dialog v-model="dialog" max-width="700" style="z-index: '999'">
        <AgencyAddress
          :id="id"
          :agencyName="name"
          :address="address"
          :address2="address2"
          :city="city"
          :state="state"
          :zip="zip"
          :country="country"
          :phone="phone"
          :phoneExt="phoneExt"
          :email="email"
          :code="code"
          :companyId="companyId"
          :countryCode="countryCode"
          :phoneTypeId="phoneTypeId"
          :aoId="selectedAO.id"
          :aoName="selectedAO.ao.substr(selectedAO.ao.indexOf(' ') + 1)"
          :addressTypeId="addressTypeId"
          :countryId="countryId"
          :primaryAgencyInd="primaryAgencyInd"
        />
      </v-dialog>
    </span>
  </v-layout>
</template>
<script>
import AgencyAddress from "@/components/agency-address.vue";
import EventBus from "@/eventBus.js";

import API, { graphqlOperation } from "@aws-amplify/api";
import * as queries from "@/graphql/queries";
import utilityMixins from "@/utility-mixins.js";
export default {
  components: {
    AgencyAddress,
  },
  mixins: [utilityMixins],
  created() {
    this.isMobileCheck();

    window.addEventListener("resize", this.isMobileCheck);

    if (this.isAgencyUser) this.getAOForUser();
    else this.getAOs();
  },
  mounted() {
    EventBus.$on(
      "addressChangeCancel",
      function () {
        this.dialog = false;
      }.bind(this)
    );
    EventBus.$on(
      "addressChange",
      function () {
        this.dialog = false;
        this.$modal.show("savedModal");
      }.bind(this)
    );
  },
  watch: {
    selectedAO() {
      this.select = null;
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.isMobileCheck);

    EventBus.$off("addressChangeCancel");
    EventBus.$off("addressChange");
  },
  computed: {
    id() {
      if (this.select) return this.select.id;
      return null;
    },
    name() {
      if (this.select) return this.select.name;
      return null;
    },

    code() {
      if (this.select) return this.select.code;
      return null;
    },
    companyId() {
      if (this.select) return this.select.companyId;
      return null;
    },
    countryId() {
      if (this.select) return this.select.countryId;
      return null;
    },
    countryCode() {
      if (this.select) return this.select.countryCode;
      return null;
    },
    phoneTypeId() {
      if (this.select) return this.select.phoneTypeId;
      return null;
    },
    addressTypeId() {
      if (this.select) return this.select.addressTypeId;
      return null;
    },
    address() {
      if (this.select) return this.select.address1;
      return null;
    },
    address2() {
      if (this.select) return this.select.address2;
      return null;
    },
    city() {
      if (this.select) return this.select.city;
      return null;
    },
    state() {
      if (this.select) return this.select.state;
      return null;
    },
    zip() {
      if (this.select) return this.select.zip;
      return null;
    },
    country() {
      if (this.select) return this.select.country;
      return null;
    },
    phone() {
      if (this.select) return this.select.phone;
      return null;
    },
    phoneExt() {
      if (this.select) return this.select.phoneExt;
      return null;
    },
    email() {
      if (this.select) return this.select.email;
      return null;
    },
    primaryAgencyInd() {
      return this.select.primaryAgencyInd;
    },
    sortedAoItems() {
      return this.sortByName(this.aoItems, "name");

      // let sorted = this.aoItems;

      // return sorted.sort((a, b) => {
      //   let nameArrayA = a.ao.split(" ");
      //   let nameArrayB = b.ao.split(" ");

      //   let lastA = nameArrayA[nameArrayA.length - 1];
      //   let lastB = nameArrayB[nameArrayB.length - 1];

      //   if (lastA > lastB) return 1;
      //   if (lastB > lastA) return -1;
      //   return 0;
      // });
    },
    sortedAgencies() {
      if (this.selectedAO == null || this.selectedAO.id == null) return [];

      let sorted = this.agencies.filter((i) => i.aoId == this.selectedAO.id);

      if (!sorted) return [];

      // return sorted.sort((a, b) => {
      //   if (a.name > b.name) return 1;
      //   if (b.name > a.name) return -1;
      //   return 0;
      // });

      return sorted;
    },
  },
  data() {
    return {
      select: {},
      selectedAO: {},
      dialog: false,
      waitCircle: false,
      enableAgencySelection: false,
      aoItems: [],
      agencies: [],
    };
  },
  methods: {
    async getAOForUser() {
      try {
        let AO_Op = await API.graphql(
          graphqlOperation(queries.getAOByUser, {
            agentNum: this.$store.state.currentUser.agentNum,
            company: this.$store.state.currentCompany,
          })
        ).catch((e) => {
          this.addToErrorLogs(
            "agency-selection.vue getAOForUser getAOByUser",
            e
          );
          this.$modal.show("errorModal");
          return;
        });

        if (AO_Op) {
          let AO = AO_Op.data.getAOByUser;

          let name = (
            (AO.LastName + ", " + AO.FirstName).trim() +
            " " +
            AO.MiddleName
          ).trim();

          if (AO.LastName.trim() == "Office" && AO.FirstName.trim() == "Home")
            name = "Home Office";

          let id = AO.AgentNumPrimary;
          this.selectedAO = { ao: id + " " + name, id: id, name: name };
          this.getAgencies(true);
        } else {
          this.waitCircle = false;
          this.addToErrorLogs(
            "agency-selection.vue getAOForUser",
            new Error("AO data not retrieved.")
          );
          this.$modal.show("errorModal");
        }
      } catch (e) {
        this.waitCircle = false;
        this.addToErrorLogs("agency-selection.vue getAOForUser", e);
        this.$modal.show("errorModal");
      }
    },
    async getAgencies(initialAgencyUserCall) {
      this.waitCircle = true;

      let offices = await API.graphql(
        graphqlOperation(queries.getAgenciesByAONum, {
          aoNum: this.selectedAO.id,
          company: this.$store.state.currentCompany,
        })
      ).catch((e) => {
        this.addToErrorLogs(
          "agency-selection getAgencies getAgenciesByAONum",
          e
        );
        this.waitCircle = false;
        this.$modal.show("errorModal");
        this.agencies = [];
        return;
      });

      this.agencies = [];

      for (let office of offices.data.getAgenciesByAONum) {
        let agency = {
          aoId: office.AOAgentNumPrimary,
          code: office.AgencyCode,
          name: office.AgencyName,
          address1: office.AddressLine1,
          address2: office.AddressLine2,
          city: office.City,
          state: office.StateProvinceCode,
          zip: office.PostalCode,
          phone: office.AreaCode + office.PhoneNum,
          phoneExt: office.PhoneExtensionNum,
          country: office.CountryName,
          email: office.Email,
          companyId: office.GLCompanyID,
          countryCode: office.ISOCountryCode,
          phoneTypeId: office.GLPhoneTypeID,
          addressTypeId: office.GLAddressTypeID,
          countryId: office.GLCountryID,
          id: office.EntAgencyID,
          primaryAgencyInd: office.PrimaryAgencyInd,
        };

        if (agency.phone == "0") {
          agency.phone = "";
        }

        this.agencies.push(agency);
      }
      this.enableAgencySelection = true;

      if (this.isAgencyUser && this.agencies.length == 1) {
        this.select = this.agencies[0];

        if (initialAgencyUserCall) this.gotoAddressChange();
      }

      this.waitCircle = false;
    },
    async getAOs() {
      this.waitCircle = true;
      let AOs = await API.graphql(
        graphqlOperation(queries.getAOs, {
          company: this.$store.state.currentCompany,
        })
      ).catch((e) => {
        this.waitCircle = false;
        this.addToErrorLogs("Hierarchy getAOs", e);
        this.$modal.show("errorModal");
        return;
      });

      let AOsInJSON = JSON.parse(JSON.stringify(AOs));

      this.items = [];
      if (AOsInJSON && AOsInJSON.data && AOsInJSON.data.getAOs.length) {
        for (let AO of AOsInJSON.data.getAOs) {
          let name = (
            (AO.LastName + ", " + AO.FirstName).trim() +
            " " +
            AO.MiddleName
          ).trim();

          if (AO.LastName.trim() == "Office" && AO.FirstName.trim() == "Home")
            name = "Home Office";

          let id = AO.AgentNumPrimary;

          this.aoItems.push({ ao: id + " " + name, id: id, name: name });
        }
      }

      this.waitCircle = false;
    },
    gotoAddressChange() {
      this.dialog = true;
    },
  },
};
</script>
<style scoped>
.drop {
  margin-top: 75px;
  overflow: auto;
  min-height: 700px;
}
.waitCircle {
  z-index: 50;
  position: absolute;
  top: 42%;
  left: 47%;
}
</style>
